export const newGame = (gameSize) => (
  {
    type: 'NEW_GAME',
    gameSize,
  }
);